import { APIEndpoint, RequestInput } from "../types";
import { LEGACY_BACKEND_URL } from '../config';

export enum HTTPMethods {
  DELETE = "DELETE",
  GET = "GET",
  PATCH = "PATCH",
  POST = "POST",
  PUT = "PUT",
}

export enum APIRequests {
  UserBloodResultsList = "userbloodresultslist",
  UserBloodTestDataUpdate = "userbloodtestdataupdate",
  UserGet = "userget", 
  UserGenerateShareLink = "usergeneratesharelink",
  UserJourneyGet = "userjourneyget",
  UserJourneyUpdate = "userjourneyupdate",
  UserUpdateProfile = "userupdateprofile",
}

const apiEndpoints: Record<APIRequests, APIEndpoint> = {
  userbloodresultslist: {
    path: "/user_blood_test_data/aidx_vitamin_get",
    method: HTTPMethods.GET,
    queryParams: ["email", "token"]
  },
  userbloodtestdataupdate: {
    path: "/user_blood_test_data/update",
    method: HTTPMethods.POST,
    queryParams: ["token"]
  },
  userget: {
    path: "/user/get-user-with-jwt-check",
    method: HTTPMethods.GET,
    queryParams: ["email", "token"]
  },
  usergeneratesharelink: {
    path: "/user/generate-share-link",
    method: HTTPMethods.GET,
    queryParams: ["email", "token"]
  },
  userjourneyget: {
    path: "/user/journey",
    method: HTTPMethods.GET,
    queryParams: ["email", "token", "_sort_key", "_sort_dir"]
  },
  userjourneyupdate: {
    path: "/user/journey-update",
    method: HTTPMethods.POST,
    queryParams: ["token"],
    pathParams: ["id"]
  },
  userupdateprofile: {
    path: "/user/update_profile",
    method: HTTPMethods.POST,
    queryParams: ["token"]
  },
};

// eslint-disable-next-line complexity
export const MakeRequest = (
  req: APIRequests,
  input: RequestInput
): RequestInfo => {
  const { method, path, pathParams, queryParams } = apiEndpoints[req];

  let fixedPath = LEGACY_BACKEND_URL + path;
  if (pathParams?.length && input.pathParams) {
    for (const p of pathParams) {
      fixedPath = fixedPath.replace(`/:${p}`, `/${input.pathParams[p]}`);
    }
  }

  if (queryParams?.length && input.queryParams) {
    const params = Object.keys(input.queryParams)
      .filter(k => queryParams.indexOf(k) >= 0)
      .map(k => [k, input.queryParams?.[k] || ""]);
    fixedPath += "?" + new URLSearchParams(params);
  }

  let jsonBody = "";
  if (input.body) {
    jsonBody = JSON.stringify(input.body);
  }

  const ctrl = new AbortController();
  const sig = ctrl.signal;

  setTimeout(() => ctrl.abort(), 20000);
  return new Request(fixedPath, {
    body: jsonBody || null,
    method: method,
    signal: sig,
  });
};
